import { render, staticRenderFns } from "./MainSliderForCuratorAndTeacher.vue?vue&type=template&id=480692cf&scoped=true&"
import script from "./MainSliderForCuratorAndTeacher.vue?vue&type=script&lang=js&"
export * from "./MainSliderForCuratorAndTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480692cf",
  null
  
)

export default component.exports